// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { TermsOfServicePage } from '../pages/TermsOfServicePage/TermsOfServicePage';

export const Route = createFileRoute('/terms-of-service')({
  component: TermsOfServicePage,
});
